import "./Hhero.css";
import HeroSection from "./Herowrapper";


const Hhero = () => {

  return (
    <>
      <HeroSection />
    </>
  );
};

export default Hhero;

